import Header from "./components/Header";
import Hero from "./components/Hero";
import Updates from "./components/Updates";
import TimelineSection from "./components/TimelineSection";
import Responses from "./components/Responses";
import TopicsWall from "./components/TopicsWall";
import Archive from "./components/Archive";
import Comments from "./components/Comments";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Updates />
        <TimelineSection />
        <Responses />
        <TopicsWall />
        <Archive />
        <Comments />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}